'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reactI18next = require('react-i18next');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _playlist = require('redux/modules/playlist');

var playlistActions = _interopRequireWildcard(_playlist);

var _reactRouterRedux = require('react-router-redux');

var _TermsHint = require('../Auth/TermsHint');

var _TermsHint2 = _interopRequireDefault(_TermsHint);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./UserConsent.scss');

var UserConsent = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    playlistLoading: state.playlist.playlistLoading
  };
}, (0, _extends3.default)({}, playlistActions, { push: _reactRouterRedux.push })), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(UserConsent, _Component);

  function UserConsent() {
    (0, _classCallCheck3.default)(this, UserConsent);
    return (0, _possibleConstructorReturn3.default)(this, (UserConsent.__proto__ || (0, _getPrototypeOf2.default)(UserConsent)).apply(this, arguments));
  }

  (0, _createClass3.default)(UserConsent, [{
    key: 'onCancel',
    value: function onCancel() {
      this.props.push('/');
    }
  }, {
    key: 'onAccept',
    value: function onAccept() {
      var _props = this.props,
          loadByKeyOnAcceptDaw = _props.loadByKeyOnAcceptDaw,
          playlistKey = _props.playlistKey;

      return loadByKeyOnAcceptDaw({ key: playlistKey });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          t = _props2.t,
          playlistLoading = _props2.playlistLoading;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('homeContent', styles.page) },
        _react2.default.createElement(
          'div',
          { className: styles.header },
          t('Important information')
        ),
        _react2.default.createElement(
          'div',
          { className: styles.content },
          _react2.default.createElement(
            'p',
            null,
            t('By clicking “Accept” you acknowledge that'),
            ':'
          ),
          _react2.default.createElement(
            'p',
            null,
            '-',
            _react2.default.createElement(
              'span',
              { className: (0, _classnames2.default)(styles.marker, 'margin-left-5') },
              _react2.default.createElement(_reactI18next.Interpolate, {
                i18nKey: 'The content will lock to {{theDeviceThatIt}}',
                theDeviceThatIt: _react2.default.createElement(
                  'span',
                  { className: 'underline' },
                  t('the device that it is first played on~~The content will lock to...')
                )
              })
            ),
            '; ',
            _react2.default.createElement(
              'span',
              null,
              t('and')
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            '-',
            _react2.default.createElement(
              'span',
              { className: 'margin-left-5' },
              t('You understand and agree to the terms contained in our email to you in respect of receipt of the content')
            ),
            '.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_reactI18next.Interpolate, {
              i18nKey: 'Click ACCEPT to listen on {{thisDeviceOnly}}',
              thisDeviceOnly: _react2.default.createElement(
                'span',
                { className: 'underline' },
                t('this device only~~Click ACCEPT to listen on ...')
              )
            })
          ),
          _react2.default.createElement(
            'p',
            null,
            t('If you log into CRight using your password you can still listen on any device as usual.')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.buttons },
          _react2.default.createElement(
            _components.Button,
            { className: 'btn-default', onClick: this.onCancel },
            t('Cancel')
          ),
          _react2.default.createElement(
            _components.Button,
            { className: 'btn-primary margin-left-20', onClick: this.onAccept, loading: playlistLoading },
            t('Accept')
          )
        ),
        _react2.default.createElement(_TermsHint2.default, { nonStyled: true, className: styles.terms })
      );
    }
  }]);
  return UserConsent;
}(_react.Component), _class3.propTypes = {
  loadByKeyOnAcceptDaw: _propTypes2.default.func,
  playlistKey: _propTypes2.default.string,
  playlistLoading: _propTypes2.default.bool,
  push: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onCancel', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onCancel'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onAccept', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onAccept'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = UserConsent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UserConsent/UserConsent.js
// module id = 2133
// module chunks = 1